import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/refresh.svg'


const _withScopeId = n => (_pushScopeId("data-v-405754b8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "qrcode" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "section-divider" }, null, -1 /* HOISTED */))
const _hoisted_3 = { class: "qrcode-img-wrapper" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "refresh-btn" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "재시도", -1 /* HOISTED */))
const _hoisted_7 = {
  key: 0,
  class: "qrcode-time"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "새로고침"
}, null, -1 /* HOISTED */))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = {
  key: 1,
  class: "qrcode-time-out"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" 유효시간이 초과되었습니다."),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 다시 시도하시려면 [재시도]를 눌러주세요. ")
], -1 /* HOISTED */))
const _hoisted_12 = [
  _hoisted_11
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      ($setup.qrCode && $setup.timer)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: `data:image/png;base64,${$setup.qrCode}`,
            alt: "qr"
          }, null, 8 /* PROPS */, _hoisted_4))
        : _createCommentVNode("v-if", true),
      ($setup.timer <= 0)
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: "reload-qrcode",
            onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.getQrCode($event)))
          }, [
            _createElementVNode("div", _hoisted_5, [
              _createVNode($setup["InlineSvg"], {
                src: require('@/assets/icons/refresh.svg'),
                alt: "새로고침"
              }, null, 8 /* PROPS */, ["src"])
            ]),
            _hoisted_6
          ]))
        : _createCommentVNode("v-if", true)
    ]),
    ($setup.timer)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createElementVNode("span", null, _toDisplayString($setup.formattedTimer($setup.timer)), 1 /* TEXT */),
          _createElementVNode("button", {
            type: "button",
            class: "btn-refresh",
            onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.getQrCode($event)))
          }, [..._hoisted_9])
        ]))
      : _createCommentVNode("v-if", true),
    ($setup.timer <= 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [..._hoisted_12]))
      : _createCommentVNode("v-if", true)
  ]))
}